<template>
  <q-btn
    flat
    round
    dense
    size="20px"
    class="q-ml-sm no-shadow"
    color="grey-5"
    no-ripple
    icon="notifications"
  >
    <q-chip
      v-if="unreadNotificationsLength"
      color="negative"
      floating
      small
      class="q-caption"
    >
      {{ unreadNotificationsLength }}
    </q-chip>
    <q-popover class="notif-popover" anchor="bottom right" self="top right" @hide="onPopoverHide">
      <q-card-title>
        <div class="text-weight-medium">Benachrichtigungen</div>
        <div slot="right">
          <q-btn
            flat
            round
            dense
            size="sm"
            icon="done_all"
            :color="unreadNotificationsLength ? 'primary' : 'faded'"
            :disable="!unreadNotificationsLength"
            @click="markAllRead"
          >
            <q-tooltip>Alle als gelesen markieren</q-tooltip>
          </q-btn>
        </div>
      </q-card-title>

      <q-tabs inverted color="" class="a-tabs">
        <q-tab default slot="title" name="updates" label="Updates" />
        <q-tab slot="title" name="system" label="System" />

        <q-tab-pane name="updates" class="notif-popover__pane">
          <notification-list ref="updatesList" :notifications="updateTabNotifications" />
        </q-tab-pane>

        <q-tab-pane name="system" class="notif-popover__pane">
          <notification-list ref="systemList" :notifications="systemTabNotifications" />
        </q-tab-pane>
      </q-tabs>
    </q-popover>
  </q-btn>
</template>

<script>
import { mapState } from 'vuex';
import NotificationList from './NotificationList.vue';

export default {
  name: 'NotificationButton',

  components: {
    NotificationList,
  },

  data: () => ({
    twoFaHint: null,
  }),

  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('notifications', ['notifications']),

    systemTabNotifications() {
      const real = this.notifications.filter(n => n.type !== 'update');
      return this.twoFaHint ? [this.twoFaHint, ...real] : real;
    },

    updateTabNotifications() {
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

      return this.notifications
        .filter(n => n.type === 'update')
        .filter(n => new Date(n.displayDate || n.created) >= oneYearAgo);
    },

    unreadNotificationsLength() {
      const unreadReal = this.notifications.filter(n => !n.isRead).length;
      const unreadHint = this.twoFaHint && this.twoFaHint.unread ? 1 : 0;
      return unreadReal + unreadHint;
    },
  },

  async mounted() {
    // Don't show 2FA hint if user has alzuraId
    if (this.$app.whitelabel === 'alzura') return;

    const twoFaSeen = !!localStorage['2fa-notif-seen'];
    if (!twoFaSeen) await new Promise(resolve => setTimeout(resolve, 25000));

    if (this.currentUser.two_fa_status !== 'active') {
      this.twoFaHint = {
        ID: 'two-fa-hint',
        unread: !twoFaSeen,
        title: 'Zwei-Faktor-Authentifizierung nicht aktiviert',
        snippet: 'Erhöhen Sie die Sicherheit Ihres Kontos, indem Sie jetzt die Zwei-Faktor-Authentifizierung aktivieren.',
        onRead: () => {
          localStorage['2fa-notif-seen'] = true;
          this.twoFaHint.unread = false;
        },
        action: () => {
          this.$router.push('/profile-settings#manage-2factor');
        },
      };
    }
  },

  methods: {
    onPopoverHide() {
      this.$refs.systemList?.flushPendingRead();
      this.$refs.updatesList?.flushPendingRead();
    },

    markAllRead() {
      if (this.twoFaHint && this.twoFaHint.unread) {
        this.twoFaHint.onRead();
      }

      if (this.notifications.some(n => !n.isRead)) {
        this.$store.dispatch('notifications/markAllRead');
      }
    },
  },

};
</script>
<style scoped lang="stylus">
>>> .q-chip-floating {
  border-radius: 50%;
  top: 0.4em;
  right: 0.9em;
}

.notif-popover {
  width: 400px;
  max-width: 92vw;
  border-radius: 10px;
  overflow: hidden;
}

.notif-popover >>> .q-tabs-head {
  padding: 0 12px;
}

.notif-popover__pane {
  max-height: 420px;
  overflow-y: auto;
  padding: 0;
}
</style>
